/*
 * We will randomly sample many of these events to cut down on calls;
 * we only care about this behavior insofar as it alerts us to problems with the app experience in realtime.
 * In cases where we care about the real data for analytics, it is captured elsewhere
 * (ex: BufferMetricsEnhancer) and is thus available for BI, etc.
 */
export const sampleThisMetric = (percent: number) =>
  Math.round(Math.random() * 100) < percent;
